/**
 * Used for the installer details pages, the ones in modals are in modal.js
 */

// Dependencies
import $ from 'jquery';

const google = window.google;

// Module events
export default function init() {
	
	$('.js-map').each(function() {

		const $this = $(this);
		const lat = $this.data('lat');
		const long = $this.data('long');
		const latLong = new google.maps.LatLng(lat, long);

		const map = new google.maps.Map(
			document.querySelector('#map-canvas'), {
				zoom: 13,
				center: latLong,
			}   
		);
		
		const marker = new google.maps.Marker({
			position: latLong,
			map
		});
	});
	
}

